// Parses Vimeo URLs, incl. unlisted ones carrying a privacy hash:
//   https://vimeo.com/123456789
//   https://vimeo.com/123456789/abcdef1234?share=copy
//   https://player.vimeo.com/video/123456789?h=abcdef1234
export function parseVimeoUrl(url) {
  if (!url) return { id: null, hash: null, url: null };

  const [path, query = ''] = url.split('#')[0].split('?');
  const match = path.match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/([0-9a-zA-Z]+))?/);
  if (!match) return { id: null, hash: null, url: null };

  const id = match[1];
  const hash = match[2] || (query.match(/(?:^|&)h=([0-9a-zA-Z]+)/) || [])[1] || null;

  return { id, hash, url: `https://vimeo.com/${id}${hash ? `/${hash}` : ''}` };
}

export default parseVimeoUrl;



// WEBPACK FOOTER //
// ./src/utils/vimeo.js